import store from '../store'
import Subscription from './subscription'
import UserInfo from '@/lib/user-info'

export default class Account {
  static getByTask(task) {
    const taskUsername = task.username
    if (UserInfo.getUsername() === taskUsername) {
      return { nickname: UserInfo.getNickname(), iconUrl: UserInfo.getIconUrl() }
    }
    return Subscription.getMatchedSubscribingAccount(taskUsername)
  }

  static getByField(field) {
    const taskUsername = field.username
    if (UserInfo.getUsername() === taskUsername) {
      const userInfo = store.getters.userInfo
      return { nickname: UserInfo.getNickname(), iconUrl: UserInfo.getIconUrl() }
    }
    return Subscription.getMatchedSubscribingAccount(taskUsername)
  }

  static getByDevice(device) {
    const deviceUsername = device.username
    if (UserInfo.getUsername() === deviceUsername) {
      const userInfo = store.getters.userInfo
      return { nickname: UserInfo.getNickname(), iconUrl: UserInfo.getIconUrl() }
    }
    return Subscription.getMatchedSubscribingAccount(deviceUsername)
  }

  static getByRefLine(refLine) {
    const refLineUsername = refLine.username
    if (UserInfo.getUsername() === refLineUsername) {
      const userInfo = store.getters.userInfo
      return { nickname: UserInfo.getNickname(), iconUrl: UserInfo.getIconUrl() }
    }
    return Subscription.getMatchedSubscribingAccount(refLineUsername)
  }
}
